export enum KanbanCounterColor {
  SUCCESS = '#79BF1F',
  WARNING = '#FFC224',
  DANGER = '#dd3712',
  REGULAR = '#507083',
}
